// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

export const InstructedPopover: React.FC = () => {
  const nav = useNavigate();
  const goToAllocationRequests = () => {
    nav('/registry/allocationRequest');
  };
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Since you are the pledgor, you will need to allocate assets.
      </Typography>
      <Button fullWidth variant="outlined" size="small" onClick={goToAllocationRequests}>
        Go to allocation requests
      </Button>
    </Box>
  );
};
